import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow, @typescript-eslint/no-empty-interface */
import { createAction } from '../../interfaces';
import prospectService from '../../services/prospect';
import * as definitions from '../../definitions/prospect';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var actionCreators = {
  createProspectRequest: function createProspectRequest(prospect) {
    return createAction(definitions.CREATE_PROSPECT_REQUEST, prospect);
  },
  createProspectSuccess: function createProspectSuccess(prospect) {
    return createAction(definitions.CREATE_PROSPECT_SUCCESS, prospect);
  },
  createProspectFail: function createProspectFail(error) {
    return createAction(definitions.CREATE_PROSPECT_FAIL, error);
  },
  confirmProspectRequest: function confirmProspectRequest(prospect) {
    return createAction(definitions.CONFIRM_PROSPECT_REQUEST, prospect);
  },
  confirmProspectSuccess: function confirmProspectSuccess(prospect) {
    return createAction(definitions.CONFIRM_PROSPECT_SUCCESS, prospect);
  },
  confirmProspectFail: function confirmProspectFail(error) {
    return createAction(definitions.CONFIRM_PROSPECT_FAIL, error);
  },
  clearProspectErrors: function clearProspectErrors() {
    return createAction(definitions.CLEAR_PROSPECT_ERRORS);
  },
  setProspectInfo: function setProspectInfo(info) {
    return createAction(definitions.SET_PROSPECT_INFO, info);
  },
  clearProspectInfo: function clearProspectInfo() {
    return createAction(definitions.CLEAR_PROSPECT_INFO);
  },
  clearProspectData: function clearProspectData() {
    return createAction(definitions.CLEAR_PROSPECT_DATA);
  }
};
export var clearProspectData = function clearProspectData() {
  return function (dispatch) {
    var clearProspectDataAction = actionCreators.clearProspectData;
    dispatch(clearProspectDataAction());
  };
};
export var createProspect = function createProspect(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var createProspectRequest, createProspectSuccess, createProspectFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createProspectRequest = actionCreators.createProspectRequest, createProspectSuccess = actionCreators.createProspectSuccess, createProspectFail = actionCreators.createProspectFail;
              dispatch(createProspectRequest(payload));
              return _context.abrupt("return", prospectService.create(payload).then(function (prospect) {
                dispatch(createProspectSuccess(prospect));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createProspectFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var confirmProspect = function confirmProspect(payload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var confirmProspectRequest, confirmProspectSuccess, confirmProspectFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              confirmProspectRequest = actionCreators.confirmProspectRequest, confirmProspectSuccess = actionCreators.confirmProspectSuccess, confirmProspectFail = actionCreators.confirmProspectFail;
              dispatch(confirmProspectRequest(payload));
              return _context2.abrupt("return", prospectService.confirm(payload).then(function (prospect) {
                dispatch(confirmProspectSuccess(prospect));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(confirmProspectFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var clearProspectErrors = function clearProspectErrors() {
  return function (dispatch) {
    var clearProspectErrorsAction = actionCreators.clearProspectErrors;
    dispatch(clearProspectErrorsAction());
  };
};
export var setProspectInfo = function setProspectInfo(info) {
  return function (dispatch) {
    var setProspectInfoAction = actionCreators.setProspectInfo;
    dispatch(setProspectInfoAction(info));
  };
};
export var clearProspectInfo = function clearProspectInfo() {
  return function (dispatch) {
    var clearProspectInfoAction = actionCreators.clearProspectInfo;
    dispatch(clearProspectInfoAction());
  };
};